import React, { createContext, useContext } from 'react';

const ChatMessageLinksContext = createContext({
  linkRegistry: null,
  people: [],
});

export function ChatMessageLinksProvider({ linkRegistry, people, children }) {
  return (
    <ChatMessageLinksContext.Provider
      value={{ linkRegistry: linkRegistry || null, people: people || [] }}
    >
      {children}
    </ChatMessageLinksContext.Provider>
  );
}

export function useChatMessageLinks() {
  return useContext(ChatMessageLinksContext);
}
